<template>
  <div>
    <CompetitivenessRateGraph
      class="tw:h-auto tw:md:h-[450px] tw:mb-8 tw:md:mb-0"
      :series="series"
      :language="language"
      :isMobile="isMobile"
    />
  </div>
</template>
<script setup>
import CompetitivenessRateGraph from '@/components/rateConnect/opportunityArea/rateCompetitiveness/CompetitivenessRateGraph.vue'

import { useSessionValues } from '@/composables/useSessionValues'
import { useIsMobile } from '@/composables/useIsMobile'

const { isMobile } = useIsMobile(500)
const { language } = useSessionValues()

defineProps({
  series: Object,
})
</script>
